import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axios';
import toast from 'react-hot-toast';

export default function AdminPatients() {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const load = () => {
    setLoading(true);
    api.get('/admin/patients').then(r => setPatients(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const toggleActive = async (id, current) => {
    try {
      await api.post('/admin/users/' + id + '/toggle');
      toast.success(current ? 'Compte désactivé' : 'Compte activé'); load();
    } catch(e) { toast.error('Erreur'); }
  };

  const filtered = patients.filter(p =>
    p.name?.toLowerCase().includes(search.toLowerCase()) ||
    p.phone?.includes(search)
  );

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <div className="bg-gray-800 border-b border-gray-700 px-6 py-4 flex items-center gap-3">
        <Link to="/admin/dashboard" className="text-green-400">← Retour</Link>
        <h1 className="font-bold text-lg">Gestion des patients ({patients.length})</h1>
      </div>

      <div className="max-w-4xl mx-auto p-6 space-y-4">
        <input className="w-full bg-gray-700 border border-gray-600 text-white rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
          placeholder="🔍 Rechercher par nom ou téléphone..." value={search}
          onChange={e => setSearch(e.target.value)} />

        {loading ? <p className="text-center text-gray-400 py-8">Chargement...</p>
        : filtered.map(patient => (
          <div key={patient.id} className="bg-gray-800 border border-gray-700 rounded-2xl p-4">
            <div className="flex items-start justify-between">
              <div>
                <p className="font-bold">{patient.name}</p>
                <p className="text-sm text-gray-400">📱 {patient.phone}</p>
                <p className="text-sm text-gray-400">📧 {patient.email || 'Non renseigné'}</p>
                <p className="text-sm text-gray-400">📍 {patient.city || 'Non renseigné'}</p>
                <p className="text-xs text-gray-500 mt-1">
                  Inscrit le {new Date(patient.created_at).toLocaleDateString('fr-FR')}
                </p>
              </div>
              <span className={`text-xs px-2 py-1 rounded-full ${patient.is_active ? 'bg-green-900 text-green-300' : 'bg-red-900 text-red-300'}`}>
                {patient.is_active ? '🟢 Actif' : '🔴 Bloqué'}
              </span>
            </div>
            <div className="mt-3 pt-3 border-t border-gray-700">
              <button onClick={() => toggleActive(patient.id, patient.is_active)}
                className={`w-full py-2 rounded-xl text-sm font-medium ${patient.is_active ? 'bg-red-900 text-red-300 hover:bg-red-800' : 'bg-green-900 text-green-300 hover:bg-green-800'}`}>
                {patient.is_active ? '🚫 Bloquer le compte' : '✓ Réactiver le compte'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
